import { API_ENDPOINTS } from '../../constants/apiEndpoints';
import { ENVIRONMENT_CONFIG } from '../../constants/environmentConfig';
import fetcher from '../../helpers/fetcher';

export interface IFilters {
  startDate: '';
  endDate: '';
  basketId: number | '';
  establishmentIds: '';
  timezoneOffset: -330;
}
export const getMetaDataForNewsLetter = async (id: string) => {
  try {
    const res = await fetcher.post(
      `${API_ENDPOINTS.NEWSLETTER.GET_PUBLIC_NEWSLETTER_BY_ID}/${id}`,
      {},
      {},
      ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
    );

    return res;
  } catch (error) {
    throw error;
  }
};

export const getTableData = async (filters: any) => {
  try {
    const res = await fetcher.post(
      API_ENDPOINTS.NEWSLETTER.POST_GENERATED_REPORT,
      filters,
      {},
      ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
    );

    return res;
  } catch (error) {
    throw error;
  }
};

export const getChartData = async (filters: any) => {
  try {
    const res = await fetcher.post(
      API_ENDPOINTS.NEWSLETTER.POST_GENERATED_GRAPH,
      filters,
      {},
      ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
    );

    return res;
  } catch (error) {
    throw error;
  }
};
